(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-iot-scene"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const section = document.getElementById('iot-scene-section');
    const btn = document.getElementById('iot-toggle-btn');
    const btnText = btn ? btn.querySelector('.iot-btn-text') : null;

    if (!section || !btn) return;

    let isAfter = false;
    let timer = null;

    function setState(after) {
      isAfter = after;
      if (after) {
        section.classList.add('is-after');
        btnText.textContent = '外出後';
      } else {
        section.classList.remove('is-after');
        btnText.textContent = '外出前';
      }
    }

    function startTimer() {
      clearInterval(timer);
      timer = setInterval(function() {
        setState(!isAfter);
      }, 60000); // 1분
    }

    btn.addEventListener('click', function() {
      setState(!isAfter);
      startTimer(); // 클릭 시 타이머 리셋
    });

    // 초기 상태: 외출 전, 타이머 시작
    setState(false);
    startTimer();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
